import { motion } from "framer-motion";

export const ServiceCard = ({ icon, title, description, className = "", index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ y: -6 }}
    data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
    className={`group bg-white rounded-2xl border border-navy/10 p-8 shadow-sm hover:shadow-xl hover:border-accent/30 transition-shadow duration-300 ${className}`}
  >
    <div className="w-14 h-14 rounded-xl bg-navy/5 flex items-center justify-center mb-6 group-hover:bg-accent/10 transition-colors duration-300">
      {icon}
    </div>
    <h3 className="font-heading text-xl font-semibold text-navy mb-3">{title}</h3>
    <p className="text-sm leading-relaxed text-slate">{description}</p>
  </motion.div>
);
